import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, ToastController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';
import * as moment from 'moment';
import { CalendarPage } from '../../calendar/calendar';


/**
 * Generated class for the RoutemomentkokpitPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-routemomentkokpit',
  templateUrl: 'routemomentkokpit.html',
})
export class RoutemomentkokpitPage {

  startDateA: any = moment(new Date()).add(-1, 'days')
  startDateStrA: any = moment(new Date()).add(-1, 'days').format(this.gn.user.DFormat)
  startDateB: any = moment(new Date()).add(-1, 'days')
  startDateStrB: any = moment(new Date()).add(-1, 'days').format(this.gn.user.DFormat)

  Denes = moment(new Date()).format('YYYY-MM-DD')
  Denesenden: any = new Date()


  selectedroutePage: any
  SelectedMenuBank = 1

  routingTab: string = 'vehicles'
  loadingData: boolean = true
  loadingDataDrivers: boolean = true

  reportData = []
  r_routeNumber = ''
  Group = []
  GroupElements = 0

  reportData2 = []
  Group2 = []
  GroupElements2 = 0


  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public popoverCtrl: PopoverController, public toastCtrl: ToastController) {
  }



  ionViewDidLoad() {
    console.log('ionViewDidLoad RoutemomentkokpitPage');
    this.getVehiclesforRoutes()
    // this.getDriversforRoutes()

  }


  openDatePopup(_ev, _se) {
    var dd = this.startDateA
    if (_se == 2) {
      dd = this.startDateB
    }
    var _that = this;
    let popover = this.popoverCtrl.create(CalendarPage, {
      d: dd, cb: function (d) {
        if (_se == 1) {
          var ddiff = _that.getDateDifff(d, _that.startDateB)

          if (ddiff <= 0) {
            _that.startDateB = d;
            _that.startDateStrB = moment(_that.startDateB).format(_that.gn.user.DFormat)
          }
          _that.startDateA = d;
          _that.startDateStrA = moment(_that.startDateA).format(_that.gn.user.DFormat)

        } else {
          var ddiff = _that.getDateDifff(_that.startDateA, d)
          if (ddiff <= 0) {
            _that.startDateA = d;
            _that.startDateStrA = moment(_that.startDateA).format(_that.gn.user.DFormat)
          }
          _that.startDateB = d;
          _that.startDateStrB = moment(_that.startDateB).format(_that.gn.user.DFormat)
        }

      }
    })
    popover.present({ ev: _ev });
  }



  getDateDifff(_d1, _d2) {
    var d1 = moment(moment(_d1).format('YYYY-MM-DD')); //todays date
    var d2 = moment(moment(_d2).format('YYYY-MM-DD')); //todays date
    var momentalendate = moment(moment(this.Denesenden).format('YYYY-MM-DD')); //todays date
    var duration = moment.duration(d2.diff(d1));
    var days = 1 + duration.asDays();
    return days
  }


  loadReport(segment) {
    console.log(segment, 'daj mi segment')
    // this.Group = []
    // this.Group2 = []

    if (segment == 'vehicles') {
      this.getVehiclesforRoutes()
    }
    if (segment == 'employees') {
      this.getDriversforRoutes()
    }
    // this.getVehiclesforRoutes()
    // this.getDriversforRoutes()
  }

  changeSegments(name) {
    console.log('name', name)
    // this.Group = []
    // this.Group2 = []

    if (name == 'vehicles') {
      this.getVehiclesforRoutes()
    }
    if (name == 'employees') {
      this.getDriversforRoutes()
    }

  }


  getVehiclesforRoutes() {
    this.loadingData = true

    var d1 = moment(this.startDateA).format('YYYY-MM-DD')
    var d2 = moment(this.startDateB).format('YYYY-MM-DD')
    var ppid = ''


    var vid = '0'

    var _dat = {
      num: this.gn.crypt(this.r_routeNumber),
      vid: this.gn.crypt(vid),
      d1: this.gn.crypt(d1),
      d2: this.gn.crypt(d2),
      poiid: this.gn.crypt(ppid),
      uid: this.gn.crypt(this.gn.user.UserId),
      udid: this.gn.crypt(this.gn.user.driverid)
    }

    this.Group = []

    var _that = this
    this.gn._Post('/api/gn/routingfuture', _dat, function (_data) {

      _that.loadingData = false
      var _lasttourid = ''
      _that.reportData = []

      for (var i = 0; i < _data.length; i++) {

        if (_data[i].tourid + '' != _lasttourid) {
          // if (_data[i].lastvisitedpoi != '/') {
          //   _data[i].lastvisitedpoi = _data[i].lastvisitedpoi.split('#')[0]
          //   _data[i].appcolorlastvisitedpoi = _data[i].lastvisitedpoi.split('#')[1]
          // }

          var soferi = []
          if (_data[i].s1 != null) { soferi.push(_data[i].s1) }
          if (_data[i].s2 != null) { soferi.push(_data[i].s2) }
          if (_data[i].s3 != null) { soferi.push(_data[i].s3) }
          if (_data[i].s4 != null) { soferi.push(_data[i].s4) }
          _data[i].sofer = soferi.join(', ')
          _data[i].datum = moment(_data[i].startdate).format(_that.gn.user.DFormat + ' HH:mm')
          _data[i].dYMD = moment(_data[i].startdate).format('YYYY-MM-DD')

          _data[i].distance = parseFloat(_data[i].totalkm).toFixed(1) + ' Km'
          _data[i].ttime = parseInt(_data[i].totaltime)
          _data[i].ttime = _that.sec2str2(_data[i].ttime)
          var _pauses = []
          if (_data[i].pause1 + '' != '0') { _pauses.push(_data[i].pause1 + ' ' + _that.dic.l["min"]) }
          if (_data[i].pause2 + '' != '0') { _pauses.push(_data[i].pause2 + ' ' + _that.dic.l["min"]) }
          if (_data[i].pause3 + '' != '0') { _pauses.push(_data[i].pause3 + ' ' + _that.dic.l["min"]) }
          if (_data[i].pause4 + '' != '0') { _pauses.push(_data[i].pause4 + ' ' + _that.dic.l["min"]) }
          if (_data[i].pause5 + '' != '0') { _pauses.push(_data[i].pause5 + ' ' + _that.dic.l["min"]) }
          _data[i].pauses = _pauses.join(', ')
          _lasttourid = _data[i].tourid + ''

          _that.reportData.push(_data[i])
        }

        _that.reportData.sort(function (a, b) {
          return a.vehicleid - b.vehicleid;
        });

      }

      var arrayVehicles = []
      for (let i = 0; i < _that.reportData.length; i++) {
        arrayVehicles.push(_that.reportData[i].vehicleid)

      }

      var uniqueArray = arrayVehicles.filter(function (item, pos, self) {
        return self.indexOf(item) == pos;
      })

      for (let pp = 0; pp < uniqueArray.length; pp++) {
        //debugger
        _that.Group.push({ id: uniqueArray[pp], data: [], expand: true, registration: _that.gn.Vehicles[_that.gn.VehiclesDic[uniqueArray[pp]]].registration + '(' + _that.gn.Vehicles[_that.gn.VehiclesDic[uniqueArray[pp]]].code + ')' })
        for (let m = 0; m < _that.reportData.length; m++) {
          if (uniqueArray[pp] == _that.reportData[m].vehicleid) {
            _that.Group[_that.Group.length - 1].data.push(_that.reportData[m])
            _that.GroupElements++;
          }
        }
      }
      // console.log(_that.Group, '_that.Group')
    })
  }

  getDriversforRoutes() {
    this.loadingDataDrivers = true
    var d1 = moment(this.startDateA).format('YYYY-MM-DD')
    var d2 = moment(this.startDateB).format('YYYY-MM-DD')
    var ppid = ''


    var vid = '0'

    var _dat = {
      num: this.gn.crypt(this.r_routeNumber),
      vid: this.gn.crypt(vid),
      d1: this.gn.crypt(d1),
      d2: this.gn.crypt(d2),
      poiid: this.gn.crypt(ppid),
      uid: this.gn.crypt(this.gn.user.UserId),
      udid: this.gn.crypt(this.gn.user.driverid)
    }

    this.Group2 = []

    var _that = this
    this.gn._Post('/api/gn/routingfuture', _dat, function (_data) {
      //debugger

      _that.loadingDataDrivers = false
      var _lasttourid = ''
      _that.reportData2 = []

      for (var i = 0; i < _data.length; i++) {

        if (_data[i].tourid + '' != _lasttourid) {


          var soferi = []
          if (_data[i].s1 != null) { soferi.push(_data[i].s1) }
          if (_data[i].s2 != null) { soferi.push(_data[i].s2) }
          if (_data[i].s3 != null) { soferi.push(_data[i].s3) }
          if (_data[i].s4 != null) { soferi.push(_data[i].s4) }
          _data[i].sofer = soferi.join(', ')
          _data[i].datum = moment(_data[i].startdate).format(_that.gn.user.DFormat + ' HH:mm')
          _data[i].dYMD = moment(_data[i].startdate).format('YYYY-MM-DD')

          _data[i].distance = parseFloat(_data[i].totalkm).toFixed(1) + ' Km'
          _data[i].ttime = parseInt(_data[i].totaltime)
          _data[i].ttime = _that.sec2str2(_data[i].ttime)
          var _pauses = []
          if (_data[i].pause1 + '' != '0') { _pauses.push(_data[i].pause1 + ' ' + _that.dic.l["min"]) }
          if (_data[i].pause2 + '' != '0') { _pauses.push(_data[i].pause2 + ' ' + _that.dic.l["min"]) }
          if (_data[i].pause3 + '' != '0') { _pauses.push(_data[i].pause3 + ' ' + _that.dic.l["min"]) }
          if (_data[i].pause4 + '' != '0') { _pauses.push(_data[i].pause4 + ' ' + _that.dic.l["min"]) }
          if (_data[i].pause5 + '' != '0') { _pauses.push(_data[i].pause5 + ' ' + _that.dic.l["min"]) }
          _data[i].pauses = _pauses.join(', ')
          _lasttourid = _data[i].tourid + ''

          _that.reportData2.push(_data[i])
        }

        _that.reportData2.sort(function (a, b) {
          return a.s1 - b.s1;
        });

      }

      var arrayDrivers = []
      for (let i = 0; i < _that.reportData2.length; i++) {
        arrayDrivers.push(_that.reportData2[i].s1)

      }

      var uniqueArray = arrayDrivers.filter(function (item, pos, self) {
        return self.indexOf(item) == pos;
      })

      for (let pp = 0; pp < uniqueArray.length; pp++) {
        _that.Group2.push({ id: uniqueArray[pp], data: [], expand: true })
        for (let m = 0; m < _that.reportData2.length; m++) {
          if (uniqueArray[pp] == _that.reportData2[m].s1) {
            _that.Group2[_that.Group2.length - 1].data.push(_that.reportData2[m])
            _that.GroupElements2++;
          }
        }
      }
      console.log(_that.Group2, '_that.Group')
    })

  }





  sec2str2(_sec) {
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"] + ' ' + s + this.dic.l["sec"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      // console.log("sec2str2")  
      return str;
    }
    else {
      return -1;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/routing/routemomentkokpit/routemomentkokpit.ts